// extracted by mini-css-extract-plugin
export var md = "_1h-4";
export var semantic = "_1h-5";
export var sm = "_1h-3";
export var text = "_1h-6";
export var toggleInput = "_1h-0";
export var toggleSwitch = "_1h-1";
export var xs = "_1h-2";